import React from 'react';
import { X, AlertTriangle } from 'lucide-react';
import '../../styles/marketplace.css';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = "Delete", cancelText = "Cancel", isDestructive = false }) => {
    if (!isOpen) return null;

    return (
        <div className="mp-modal-overlay">
            <div className="mp-modal-content" style={{ maxWidth: '400px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', borderBottom: '1px solid #E5E7EB' }}>
                    <h2 style={{ fontSize: '18px', fontWeight: '700', color: '#111827', margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {isDestructive && <AlertTriangle size={20} color="#EF4444" />}
                        {title}
                    </h2>
                    <button
                        onClick={onClose}
                        style={{ padding: '8px', borderRadius: '50%', border: 'none', background: 'transparent', cursor: 'pointer', color: '#6B7280' }}
                    >
                        <X size={20} />
                    </button>
                </div>

                <div style={{ padding: '24px', color: '#4B5563', fontSize: '15px' }}>
                    {message}
                </div>

                <div style={{ display: 'flex', gap: '12px', padding: '16px 24px', background: '#F9FAFB', borderRadius: '0 0 16px 16px' }}>
                    <button
                        onClick={onClose}
                        style={{ flex: 1, padding: '10px', background: 'white', border: '1px solid #D1D5DB', borderRadius: '8px', fontWeight: '600', color: '#374151', cursor: 'pointer' }}
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        className={isDestructive ? '' : 'mp-btn-primary'} // Use primary if not destructive, generic red if destructive
                        style={isDestructive ? { flex: 1, padding: '10px', background: '#EF4444', border: 'none', borderRadius: '8px', fontWeight: '600', color: 'white', cursor: 'pointer' } : { flex: 1 }}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
